module.exports = require('./helpers/bundle-url').getBundleURL('augD1') + "logo.c51670a8.svg";